export default function TableIcon({ width = 13, height = 13, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 13 13' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path d='M4.5 0.500122V12.5' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M12.5 4.49988H0.5' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M12.5 8.5H0.5' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
      <path
        d='M11.5 0.5H1.5C0.94772 0.5 0.5 0.94772 0.5 1.5V11.5C0.5 12.0523 0.94772 12.5 1.5 12.5H11.5C12.0523 12.5 12.5 12.0523 12.5 11.5V1.5C12.5 0.94772 12.0523 0.5 11.5 0.5Z'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
